// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.CreateTask-module__titleBox--fzrHM {
    display: flex;
    justify-content: space-between;
}

.CreateTask-module__titleBox--fzrHM>h1 {
  color: #6F879C;
  font-size: 30px;
  font-weight: 500;
}

.CreateTask-module__btnBack--NuDwo {
    text-transform: none !important;
    color: #0054E6 !important;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 70px;
    gap: 10px;
}
  .CreateTask-module__formBox--x9Unj {
    display: flex;
    justify-content: center; 
    align-items: center; 
    margin-top: 30px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    min-height: 50vh;
    background-color: white;
    overflow: hidden;
    width: 100%;
  }
  
  .CreateTask-module__formContent--bHAtd {
    display: flex;
    flex-direction: column;
    gap: 15px;   
    width: 90%;    
  }
  .CreateTask-module__dataPicker--ecfJ1,
  .CreateTask-module__dataPicker--ecfJ1 > div {
    height: 40px !important;
  }
  .CreateTask-module__selectsBox--Pk0Lh,
  .CreateTask-module__dopBox--o_I9r {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .CreateTask-module__selectsBox--Pk0Lh > div {
    width: 50%;
  }

  .CreateTask-module__dopBox--o_I9r > div {
    width: 100%;
  }
  .CreateTask-module__actionsBtnBox--Zy1im {
    display: flex;
    gap: 20px;
    margin-top: 20px;
    justify-content: center;
  }
@media (max-width: 1000px) {
    .CreateTask-module__titleBox--fzrHM {
        flex-direction: column;
        justify-content: normal;
        align-items: normal;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/create-task/CreateTask.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,SAAS;AACb;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;IACpD,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;EACA;;IAEE,uBAAuB;EACzB;EACA;;IAEE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,uBAAuB;EACzB;AACF;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ","sourcesContent":["\r\n.titleBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.titleBox>h1 {\r\n  color: #6F879C;\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n}\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    color: #0054E6 !important;\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    height: 70px;\r\n    gap: 10px;\r\n}\r\n  .formBox {\r\n    display: flex;\r\n    justify-content: center; \r\n    align-items: center; \r\n    margin-top: 30px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    min-height: 50vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n    width: 100%;\r\n  }\r\n  \r\n  .formContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;   \r\n    width: 90%;    \r\n  }\r\n  .dataPicker,\r\n  .dataPicker > div {\r\n    height: 40px !important;\r\n  }\r\n  .selectsBox,\r\n  .dopBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 20px;\r\n  }\r\n  .selectsBox > div {\r\n    width: 50%;\r\n  }\r\n\r\n  .dopBox > div {\r\n    width: 100%;\r\n  }\r\n  .actionsBtnBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    justify-content: center;\r\n  }\r\n@media (max-width: 1000px) {\r\n    .titleBox {\r\n        flex-direction: column;\r\n        justify-content: normal;\r\n        align-items: normal;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleBox": `CreateTask-module__titleBox--fzrHM`,
	"btnBack": `CreateTask-module__btnBack--NuDwo`,
	"formBox": `CreateTask-module__formBox--x9Unj`,
	"formContent": `CreateTask-module__formContent--bHAtd`,
	"dataPicker": `CreateTask-module__dataPicker--ecfJ1`,
	"selectsBox": `CreateTask-module__selectsBox--Pk0Lh`,
	"dopBox": `CreateTask-module__dopBox--o_I9r`,
	"actionsBtnBox": `CreateTask-module__actionsBtnBox--Zy1im`
};
export default ___CSS_LOADER_EXPORT___;
